import { CdkMenuTrigger } from '@angular/cdk/menu';
import { ConnectedPosition } from '@angular/cdk/overlay';
import {
  ChangeDetectionStrategy,
  Component,
  TemplateRef,
  computed,
  input,
  output,
} from '@angular/core';

import { MdwIcon } from '@spaces-ui/meadow/icons';
import { DropdownArrow } from '@spaces-ui/meadow/icons/svgs';

export type MdwSplitButtonType = 'Button' | 'Submit';

// Below the control, end-aligned with the caret; flips above when there's no room.
const DEFAULT_MENU_POSITION: ConnectedPosition[] = [
  { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top', offsetY: 4 },
  { originX: 'end', originY: 'top', overlayX: 'end', overlayY: 'bottom', offsetY: -4 },
];

/**
 * A main action joined to a caret that opens a CDK menu.
 *
 * Variant, size and shape use the same host classes as `mdw-button`
 * (`mdw-primary`, `large-button`, `pill-button`, …) plus `mdw-outline`.
 * The menu is supplied as an `ng-template` containing a `cdkMenu`.
 */
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'mdw-split-button',
  imports: [CdkMenuTrigger, MdwIcon],
  templateUrl: './split-button.html',
  styleUrl: './split-button.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    role: 'group',
    '[class.disabled]': 'disabled()',
  },
})
export class MdwSplitButton {
  public menu = input.required<TemplateRef<unknown>>();
  public menuLabel = input('More options');
  public menuPosition = input<ConnectedPosition[]>();
  public disabled = input(false);
  public type = input<MdwSplitButtonType>('Button');

  public buttonClick = output<MouseEvent>();

  public icons = { DropdownArrow };

  protected nativeType = computed(() => (this.type() === 'Submit' ? 'submit' : 'button'));
  protected positions = computed(() => this.menuPosition() ?? DEFAULT_MENU_POSITION);
}
